














import Vue                      from 'vue'
import {Component, Prop, Model} from 'vue-property-decorator'

function getDateDataFromString(s: string) {
    s = s.replace(/[^0-9]/g, '')
    return {
        day: s.substring(0, 2),
        month: s.substring(2, 4),
        year: s.substring(4, 8)
    }
}

@Component
export default class CustomDatepicker extends Vue {
    @Model('change', [Date, String, Number])
    protected value !: Date | string | number

    @Prop(String)
    protected label!: string

    @Prop(Boolean)
    protected disabled!: boolean

    protected convertTypedDate(v: string) {
        const {day, month, year} = getDateDataFromString(v)
        let input = day
        if (month) {
            input += `/${month}`
        }
        if (year) {
            input += `/${year}`
        }
        return input
    }

    protected parseTypedDate(v: string) {
        const {day, month, year} = getDateDataFromString(v)
        return `${month}/${day}/${year}`
    }

}
